import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EntryLayout } from '../../components/EntryLayout';
import { Icon } from '../../components/icons/Icon';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';

/** MOB/Onboarding/Intro — five fronts, stated once. Not a marketing carousel. */
export function OnboardingIntro() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const pillars = [{
    key: 'body1',
    icon: <Icon name="heart" size="md" data-id="element-3268" data-mp="cyds78mvfu0u" />
  }, {
    key: 'mind',
    icon: <Icon name="mind" size="md" data-id="element-3269" data-mp="czyn4zd3lez8" />
  }, {
    key: 'habits',
    icon: <Icon name="check" size="md" data-id="element-3270" data-mp="rwfuzgm2wbh1" />
  }, {
    key: 'community',
    icon: <Icon name="community" size="md" data-id="element-3271" data-mp="mwbehql67gqt" />
  }, {
    key: 'performance',
    icon: <Icon name="trophy" size="md" data-id="element-3272" data-mp="mv09xojwi4yn" />
  }];
  return <EntryLayout title={t('onb.intro.title')} body={t('onb.intro.body')} step={1} totalSteps={5} showBack={false} footer={<Button variant="gold" size="lg" fullWidth onClick={() => navigate('/onboarding/objetivos')} data-id="element-3274" data-mp="1ydt6jste2rxi">
          {t('onb.intro.start')}
        </Button>} data-id="element-3273" data-mp="239s3w5wp3ka2">
      <p className="bee-overline text-[8.5px] font-bold text-gold-deep" data-id="element-3275" data-mp="15g1t2ptbn4qd">
        {t('onb.intro.tag')}
      </p>
      <ul className="mt-2 space-y-2" data-id="element-3276" data-mp="19i59ztyrf1j1">
        {pillars.map(pillar => <li key={pillar.key} className="flex items-start gap-2 rounded-card border border-sand-line bg-white/60 p-2" data-id="element-3277" data-mp="19fam1sgjeykv">
            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-[10px] bg-sand-deep text-soft" data-id="element-3278" data-mp="hr8wqs8seuv8">
              {pillar.icon}
            </span>
            <span className="min-w-0" data-id="element-3279" data-mp="qiiyh6typxb0">
              <span className="block text-[13.5px] font-medium text-deep" data-id="element-3280" data-mp="qjkk258lu26z">
                {t(`onb.intro.${pillar.key}`)}
              </span>
              <span className="mt-[2px] block text-[11.5px] leading-snug text-muted" data-id="element-3281" data-mp="3q4g2kykxlapu">
                {t(`onb.intro.${pillar.key}.hint`)}
              </span>
            </span>
          </li>)}
      </ul>
    </EntryLayout>;
}